import { Typography } from "../../atoms/typography";
import { platformProps } from "../../lib";
import { useChatBubbleContext } from "./chat-bubble-context";
import { chatBubbleAuthorColor } from "./lib";
import type { ChatBubbleAuthorProps } from "./types";

/** The author's name: one line, truncated at the bubble's width. */
export const ChatBubbleAuthor = ({ children, className, testID }: ChatBubbleAuthorProps) => {
  const { variant } = useChatBubbleContext();

  return (
    <Typography
      variant="caption-md"
      color={chatBubbleAuthorColor[variant]}
      className={className}
      numberOfLines={1}
      {...platformProps({ testID, slot: "chat-bubble-author" })}
    >
      {children}
    </Typography>
  );
};

ChatBubbleAuthor.displayName = "ChatBubble.Author";
